export class Credentials {
  appKey: string;
  utoken: string;

  constructor(appKey: string, utoken: string) {
    this.appKey = appKey;
    this.utoken = utoken;
  }
}
